import React, { useCallback, useEffect, useState } from 'react';
import { getWigetGrossProfit } from 'services/gross-profit-report.service';
import { formatPrice } from 'utils/index';

const CounterReport = () => {
  const [data, setData] = useState(undefined);
  const loadData = useCallback(() => {
    getWigetGrossProfit().then((e) => {
      setData(e);
    });
  }, []);
  useEffect(loadData, [loadData]);
  console.log(data);
  return (
    <div class='bw_row bw_mt_2'>
      <div class='bw_c2'>
        <div class='bw_count_cus bw_cou_report'>
          <span class='bw_green'>
            <img src='bw_image/icon/i__dollar_re.svg' />
          </span>
          <div>
            <h4>{formatPrice(data?.total_revenue, 'đ', ',')}</h4>
            <p>Tổng doanh thu</p>
          </div>
        </div>
      </div>
      <div class='bw_c2'>
        <div class='bw_count_cus bw_cou_report'>
          <span class='bw_ogrance'>
            <img src='bw_image/icon/i__dollar_re.svg' />
          </span>
          <div>
            <h4>0 đ</h4>
            <p>Tổng tiền vốn linh kiện</p>
          </div>
        </div>
      </div>
      <div class='bw_c2'>
        <div class='bw_count_cus bw_cou_report'>
          <span class='bw_blue'>
            <img src='bw_image/icon/i__money_re.svg' />
          </span>
          <div>
            <h4>0 đ</h4>
            <p>Tổng tiền lương</p>
          </div>
        </div>
      </div>
      <div class='bw_c2'>
        <div class='bw_count_cus bw_cou_report'>
          <span class='bw_black'>
            <img src='bw_image/icon/i__money_re.svg' />
          </span>
          <div>
            <h4>{formatPrice(data?.total_discount, 'đ', ',')}</h4>
            <p>Tổng giảm giá</p>
          </div>
        </div>
      </div>
      <div class='bw_c2'>
        <div class='bw_count_cus bw_cou_report'>
          <span class='bw_red'>
            <img src='bw_image/icon/i__money_re.svg' />
          </span>
          <div>
            <h4>{formatPrice(data?.total_revenue - data?.total_discount, 'đ', ',')}</h4>
            <p>Tổng lãi gộp</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounterReport;
